import { render, staticRenderFns } from "./BaseTableWrapper.vue?vue&type=template&id=6f3b4096&"
import script from "./BaseTableWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseTableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports